import FilterBar from "./filters";
import TitleBar from "./TitleBar";

export default function Header() {
  return (
    <div className="header">
      <TitleBar />
      <FilterBar />
    </div>
  );
}
